import {
  SURVEY_ACTIVITY_LOG_MESSAGES,
  SurveyActivityLogMessage,
} from '../../constants/survey-activity-log.constants';
import { LaunchToggleField } from '../types/launch-toggle-field.types';

export const LAUNCH_ACTIVITY_LOG_MESSAGES: Record<
  LaunchToggleField,
  SurveyActivityLogMessage
> = {
  scheduledLaunch: SURVEY_ACTIVITY_LOG_MESSAGES.scheduledLaunchToggled,
  scheduledPause: SURVEY_ACTIVITY_LOG_MESSAGES.scheduledPauseToggled,
  includeExcludeRespondentsEnabled:
    SURVEY_ACTIVITY_LOG_MESSAGES.includeExcludeStatusToggled,
  includeExcludeListCleared:
    SURVEY_ACTIVITY_LOG_MESSAGES.includeExcludeListCleared,
};
